// extracted by mini-css-extract-plugin
export default {"image":"mX-z","loaded":"nX-z"};